/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lucky_Same_Jay_ZipInputs */

const fr_lucky_same_jay_zip = /** @type {(inputs: Lucky_Same_Jay_ZipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom`)
};

/**

* @param {Lucky_Same_Jay_ZipInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const lucky_same_jay_zip = /** @type {((inputs?: Lucky_Same_Jay_ZipInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lucky_Same_Jay_ZipInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_lucky_same_jay_zip(inputs)
});